import React from 'react';
import Navbar from '../../navbar/Navbar';
import Footer from '../../footer/Footer';
import AcademicsTab from './AcademicsTab';


function BestPractices() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <AcademicsTab />
                        </div>
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    Best Practices 
                                </h2>
                              <div className="row">
                                <div className="col-6">
                                    <img className='rounded w-100 border' src="https://admin.swec.ac.in/assetsswec/img/BEST-PRACTICES.jpg" alt="BEST-PRACTICES" />
                                </div>
                              </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default BestPractices
